import { render, staticRenderFns } from "./viewPicGenerica.vue?vue&type=template&id=ee6b5cd4&scoped=true&"
import script from "./viewPicGenerica.vue?vue&type=script&lang=js&"
export * from "./viewPicGenerica.vue?vue&type=script&lang=js&"
import style0 from "./viewPicGenerica.vue?vue&type=style&index=0&id=ee6b5cd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee6b5cd4",
  null
  
)

export default component.exports